export function sentryBeforeSendFilter(event) {
  const value = event?.exception?.values?.[0]?.value || "";
  const type = event?.exception?.values?.[0]?.type || "";

  const ignoredMessages = [
    "Navigation cancelled",
    "ResizeObserver loop limit exceeded",
    "NetworkError when attempting to fetch resource",
  ];

  const ignoredTypes = [
    "NavigationDuplicated",
    "ChunkLoadError",
    "ui.rage_click",
  ];

  // Ignorar por mensaje
  if (ignoredMessages.some((msg) => value.includes(msg))) {
    return null;
  }

  // Ignorar por tipo de excepción
  if (ignoredTypes.includes(type)) {
    return null;
  }

  return event;
}
